import Logo from '@assets/svg/logo-beebryte.svg'
import { useTranslation } from 'react-i18next'

/**
 * Renders the Hivolution logo image alongside its translated product name.
 *
 * @component
 * @returns {JSX.Element}
 */
const MainLogo = () => {
  const { t } = useTranslation()

  return (
    <div className="main-logo">
      <img
        src={Logo}
        alt={t('common.hivolution')}
      />
      <span>{t('common.hivolution')}</span>
    </div>
  )
}

export default MainLogo
